// state
const state = {
  crsData: {
    nameInput: '',
    birthDate: '',
    address: '',
    cellNo: '',
    amRsdpeAll: '',
    amRsdpe1: '',
    amRsdpe2: '',
    amRsdpe3: '',
    ovseRsdpe: '',
    cancel: '',
    nameInputEng: '',
    firstName: '',
    lastName: '',
    nowAddress: '',
    rsdncNatl: '',
    paymentNum: '',
    reasonWrite: '',
    reasonWrite02: '',
  },
  currentDate: '',
  acntInf: {
    dporBdt: '',
    rlhrAcntAttrYn: '',
    idfNo: '',
    th3pedporNm: '',
    polhdRelNm: '',
    fncInstCdNm: '',
    regRefNoEncry: '',
    bankNm: '',
    rlhrTrsYn: '',
    atTrsCoVo: {},
    // 마지막 화면에서 필요.
    inempYn: '',
  },
  elcSgnTrgCoVo: [],
  imageData: [],
  agrInf: {},
  documentHash: '',
  // 대표모바일에서 사용.
  mblElcSgnEcusProgInfBcVo: [],
  athData: {},
  sgnTrnsFlag: false,
  maInspeAge: '',
  isRpsMbl: false,
  cusInfo: {},
  cmpltSalCompFlag: false,
  // 대면정보
  cfntInf: {
    cfntDscMd: '',
    cfntDscPlc: '',
    inspeCfntDscMd: '',
    inspeCfntDscPlc: '',
  },
}

// mutations
const mutations = {
  changeAcntInf(state, payload) {
    console.log(payload)
    state.acntInf = { ...state.acntInf, ...payload }
  },

  changeCrsData(state, payload) {
    console.log(payload)
    state.crsData = { ...state.crsData, ...payload }
  },

  changeAgrInf(state, payload) {
    console.log(payload)
    state.agrInf = { ...state.agrInf, ...payload }
  },

  changeElcSgnTrgCoVo(state, payload) {
    console.log(payload)
    state.elcSgnTrgCoVo = { ...state.elcSgnTrgCoVo, ...payload }
  },

  pushImageData(state, payload) {
    console.log(payload)
    _.remove(state.imageData, { ctnsKdCd: payload[0].ctnsKdCd })
    state.imageData = _.unionBy(state.imageData, payload, (e) => e.imageData)
  },

  clearImageData(state) {
    state.imageData = []
  },

  changeDocumentHash(state, payload) {
    state.documentHash = payload
  },

  changeMblElcSgnEcusProgInfBcVo(state, payload) {
    state.mblElcSgnEcusProgInfBcVo = payload
  },

  changeAthData(state, payload) {
    state.athData = payload
  },

  changeSgnTrnsFlag(state, flag) {
    state.sgnTrnsFlag = flag
  },

  changeMaInspeAge(state, payload) {
    state.maInspeAge = payload || ''
  },

  isRpsMbl(state, flag) {
    state.isRpsMbl = flag
  },

  changeCusInfo(state, payload) {
    state.cusInfo = payload
  },

  changeCmpltSalCompFlag(state, flag) {
    state.cmpltSalCompFlag = flag
  },

  changeCfntInf(state, payload) {
    state.cfntInf = { ...state.cfntInf, ...payload }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
